const Loading = () => {
  return (
    <div className='loading'>
            <img src="/assets/images/others/loading.gif?v=20260409"></img>
    </div>
  )
}
export default Loading